import Utilities from "@/common/utilities";

export default class ReportingSalesActivityModel {
    sku: string | undefined;
    item: string | undefined;
    
    price: number | undefined;
    tax: number | undefined;
    // Per-unit tax as charged. Recorded on the sale because price x tax cannot reproduce it for a
    // tax-inclusive item - price already has the tax stripped out and rounded ($2.00 @ 5.5% is stored
    // as 1.90 with 0.10 of tax, so price x tax x 2 gives 0.21 instead of 0.20).
    taxAmount: number | undefined;

    saleQuantity: number | undefined;
    refundQuantity: number | undefined;

    static from(json: string): ReportingSalesActivityModel {
        let model = Object.assign(new ReportingSalesActivityModel(), json);
                
        return model;
    }

    get salesPrice(): number {        
        return this.price! * this.saleQuantity!
    }

    // Tax on one unit as charged. Rows written before taxAmount was recorded carry 0, and for those
    // price x tax is the right fallback - tax-inclusive items weren't distinguishable then anyway.
    private get unitTax(): number {
        return this.taxAmount! > 0 ? this.taxAmount! : this.price! * this.tax!;
    }

    get salesTax(): number {
        return this.unitTax * this.saleQuantity!
    }

    get refundPrice(): number {
        return this.price! * this.refundQuantity!;
    }

    get refundTax(): number {
        return this.unitTax * this.refundQuantity!
    }


    get netSale(): number {
        var sales = this.price! * this.saleQuantity!;
        var refunds = this.price! * this.refundQuantity!;
        return sales - refunds;
    }

    get netTax(): number {
        var sales = this.unitTax * this.saleQuantity!;
        var refunds = this.unitTax * this.refundQuantity!;
        return sales - refunds;
    }

    get netQuantity(): number {        
        return this.saleQuantity! - this.refundQuantity!;
    }
    
    get total(): number {        
        return this.netSale + this.netTax;
    }

  }
  